export default __webpack_public_path__ + "static/media/Park.52b84bb6.svg";